import { render, staticRenderFns } from "./automation-single.vue?vue&type=template&id=61de3b22"
import script from "./automation-single.vue?vue&type=script&lang=js"
export * from "./automation-single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports